import React from 'react'

import {needHelpButtonWrapper} from './styles'
import {styled} from 'stitches/config'
import {useTranslation} from 'react-i18next'

const StyledNeedHelpButtonWrapper = styled('div', needHelpButtonWrapper)

const NeedhelpPlaceholderView = (): React.ReactElement => {
    const {t} = useTranslation()
    return (
        <StyledNeedHelpButtonWrapper>
            <button type='button'>{t('Need help?')}</button>
        </StyledNeedHelpButtonWrapper>
    )
}

export default NeedhelpPlaceholderView
